import styled from 'styled-components/macro';
import { DisplayOldToNew } from './DisplayOldToNew';
import { AmendmentStatus } from '../../slice/types';
import { DisplayFieldHorizontal } from '../DisplayFieldHorizontal';
import { useTranslation } from 'react-i18next';
import { translations } from '../../../../../locales/translations';
import { Divider, Grid } from '@mui/material';
import { ChangeBillDateTable } from './ChangeBillDateTable';
import { commonStyle } from '../../../../../styles/theme/themes';
import React, { useState } from 'react';
import { SectionStatusBlock } from './SectionStatusBlock';
import moment from 'moment';
import { DisplayFieldVertical } from '../DisplayFieldVertical';
export function ChangeBillDateCard(props) {
  const { t } = useTranslation();
  const changeBillDateData = props.data.data;
  const relatedSections = props.data.relatedSections;
  const changeBillDateStatus = props.data.status;
  const status =
    changeBillDateStatus === AmendmentStatus.PENDING
      ? translations.biType.Pending
      : translations.biType.Complete;
  const [selecting, setSelecting] = useState(false);

  const directToURL = () => {
    if (changeBillDateData.workflowURL) {
      window.open(changeBillDateData.workflowURL, '_blank');
    }
  };
  // const updateDisplayCBD = () => {
  //   setSelecting(!selecting);
  // };

  return (
    <Wrapper>
      {changeBillDateData &&
      <div
        className={`card ${changeBillDateStatus === AmendmentStatus.COMPLETE ? 'complete' : 'pending'} ${selecting && 'highlight'}`}>
        <Grid container className='header'>
          <Grid item md={4}>
            {t(translations.biType.changeBillDate)}
          </Grid>
          <Grid item md={4} className='center workflow-url' onClick={directToURL}>
            {changeBillDateData.workflowId}
          </Grid>
          <Grid item md={4} className='right'>
            {t(status)}
          </Grid>
        </Grid>
        <Divider />
        <div className='content'>
          <div className='create-date'>
            <DisplayFieldHorizontal
              label={translations.contractDetail.amendment.approvalDate}
              value={moment(changeBillDateData.approvalDate).format('YYYY-MM-DD HH:mm:ss')}
            />
          </div>
          <DisplayOldToNew
            label={translations.contractDetail.amendment.contractStartDate}
            oldValue={changeBillDateData.oldContractStartDate}
            newValue={changeBillDateData.newContractStartDate}
          />
          <DisplayOldToNew
            label={translations.contractDetail.amendment.contractEndDate}
            oldValue={changeBillDateData.oldContractEndDate}
            newValue={changeBillDateData.newContractEndDate}
          />
          <DisplayOldToNew
            label={translations.contractDetail.amendment.contractTerm}
            oldValue={changeBillDateData.oldContractTerm}
            newValue={changeBillDateData.newContractTerm}
          />
          {relatedSections &&
          <div className='row status'>
            {Object.keys(relatedSections).map((item, index) => (
              <SectionStatusBlock sectionName={item} sectionStatus={relatedSections[item]} />
            ))}
          </div>
          }
          <ChangeBillDateTable
            contractLineData={changeBillDateData.products}
          />
          { changeBillDateData.remarksToFinance && <Grid container className='row'>
            <Grid item marginTop={3} xs={12} md={12} lg={12}>
              <DisplayFieldVertical
                label={translations.contractDetail.amendment.remarksFromSunEOffice}
                value={changeBillDateData.remarksToFinance}
                minRows={3}
              />
            </Grid>
          </Grid>
          }
        </div>
      </div>
      }
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .card {
    padding: 5px;
    margin: 5px 0;
    border-radius: 5px;
    box-shadow: ${commonStyle.boxShadow};
  }

  .complete {
    background-color: ${p => p.theme.complete};
  }

  .pending {
    background-color: ${p => p.theme.pending};
  }

  .highlight {
    border: 2px solid ${p => p.theme.primary};
    margin: 3px -2px -2px -2px;
  }

  .header {
    .workflow-url {
      cursor: pointer;
      text-decoration: underline;

      &:hover {
        opacity: 0.8;
      }
    }

    .center {
      text-align: center;
    }

    .right {
      text-align: right;
    }
  }

  .content {
    background-color: white;

    .create-date {
      padding-top: 5px;
    }

    .row {
      padding-top: 5px;
    }

    .status {
      display: flex;
      margin: 0 5px;
    }
  }
`;
